import {
  capitalizeAndPrefixKeys,
  isEmptyBeacon,
  RawRumData,
  RawUserTimingData,
} from "./beacon-util";
import { trackingEventArray, trackingPIArray } from "./filter-list";

/**
 *
 *
 *
 *
 */
export function trackingEndpointLogic(
  rumData: RawRumData | RawUserTimingData
): void {
  const AddPIMetricList: RawRumData = filterFor(rumData, trackingPIArray);
  const AddEventMetricList: RawRumData = filterFor(rumData, trackingEventArray);
  if (!isEmptyBeacon(AddPIMetricList)) {
    trackingAddMergeToPageImpression(capitalizeAndPrefixKeys(AddPIMetricList));
  }
  if (!isEmptyBeacon(AddEventMetricList)) {
    trackingAddEvent(capitalizeAndPrefixKeys(AddEventMetricList));
  }
}

/**
 *
 *
 *
 *
 */
export function trackingAddMergeToPageImpression(
  metricData: RawRumData | RawUserTimingData
): void {
  if (!isEmptyBeacon(metricData)) {
    window.o_global.eventQBus.emit(
      "tracking.bct.addToPageImpressionWithStrategy",
      metricData,
      "discard"
    );
  }
}

/**
 *
 *
 *
 *
 */
export function trackingAddEvent(
  metricData: RawRumData | RawUserTimingData
): void {
  if (!isEmptyBeacon(metricData)) {
    window.o_global.eventQBus.emit("tracking.bct.submitEvent", metricData);
  }
}

/**
 *
 *
 *
 */
function filterFor(metricData: RawRumData, filterList: string[]): RawRumData {
  const filteredMetricData: RawRumData = {};
  Object.entries(metricData).forEach(([key, value]) => {
    if (filterList.includes(key)) {
      /*                                                        */
      filteredMetricData[key] = value;
    }
  });
  return filteredMetricData;
}
